import React from 'react';
import { EditPage } from '@components/common';
import TagForm from '@components/common/forms/TagForm';

const TagEditPage = () => {
    return (
        <EditPage
            modelName="tags"
            FormComponent={TagForm}
        />
    );
};

export default TagEditPage;
